/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Destination } from 'reactApp/ui/DataListItemCommonComponents/Destination/Destination';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { AttachItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface AttachProps extends AttachItemProps {
    checkboxClassname?: string;
}

export const Attach: FC<AttachProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox
                    viewType={EViewMode.list}
                    className={props.checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    isVirus={false}
                    ext={props.ext || ''}
                    author={props.owner}
                    isPublic={props.isPublic}
                />
            </TableColumn>
            <TableColumn width="60%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} id={props.id} />
            </TableColumn>
            <TableColumn width="40%" overflow="hidden">
                <Destination destination={props.subject} author={props.owner} openAttachLetter={props.openAttachLetter} isAttaches />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.mtime} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} onSaveToCloud={() => props.onClone('attaches-autodelete-tooltip')} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Download
                    onClick={props.onDownload}
                    ext={props.ext}
                    size={props.size}
                    id={props.id}
                    storage={props.storage}
                    viewType={EViewMode.list}
                />
            </TableColumn>
        </>
    );
};
